var _circle, _circle2, _ellipse, _ellipse2, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 217,
    viewBox: "0 0 185 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "#8FACCF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "url(#paint0_linear_11_1156)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1156",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 70,
    width: 103,
    height: 147
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4999,
    cy: 96.5663,
    rx: 27.5893,
    ry: 26.5663,
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5,
    cy: 172.723,
    rx: 51.5,
    ry: 44.2771,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1156)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.0401,
    cy: 103.208,
    rx: 85.067,
    ry: 81.9127,
    fill: "#E9E4D4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 133.5C80.2601 141.184 84.3711 144.724 93 149.5M93 149.5C100.172 143.983 103.787 140.482 109.5 133.5M93 149.5C93 149.5 93 195.5 93 183",
    stroke: "#4763AC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1156",
    x1: 93,
    y1: -40,
    x2: 92.5,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426985,
    stopColor: "#25374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768372,
    stopColor: "#547BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/Account Icon.ee83cb8c8c8589347ba0aa1007542b41.svg";
export { ForwardRef as ReactComponent };